export const DEFAULT_CRM_TOKEN = 'x078pgbue2h';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/logo.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['13'];
export const faqArticleIds = ['3', '4', '5', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
